// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__10nnm","buttons":"RemoveExpirationActionButtons_buttons__1M9mN"};